import React, { useEffect } from 'react';
import { FaWarehouse, FaIndustry, FaBoxes, FaBoxOpen, FaArrowAltCircleDown, /*FaFilter,*/ FaYoutube } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';

const Menu = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  useEffect(() => {
    if (!userInfo.username || !userInfo.company) {
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
    <div className="menu-container">
      <header className="header">
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h3>Empresa: {userInfo.dpc_id} - {userInfo.company}</h3>
        <h1>Por favor clique sobre a operação desejada. <FaArrowAltCircleDown size={35} /></h1>
      </header>
      <div className="buttons-container">
        <button onClick={() => handleNavigation('/almoxarifado')} className="menu-button">
          <FaWarehouse size={30} />
          <span>Almoxarifado</span>
        </button>
        <button onClick={() => handleNavigation('/Solicitacoes')} className="menu-button">
          <FaBoxOpen size={30} />
          <span>Acompanhamento Pedido de Almoxarifado</span>
        </button>
        <button onClick={() => handleNavigation('/producao')} className="menu-button">
          <FaIndustry size={30} />
          <span>Produção</span>
        </button>
        <button onClick={() => handleNavigation('/estoque')} className="menu-button">
          <FaBoxes size={30} />
          <span>Estoque</span>
          </button>
        {/*userInfo.relatorio === 'T' && (
        <button onClick={() => handleNavigation('/relatorio')} className="menu-button">
          <FaFilter size={30} />
          <span>Relatório</span>
        </button>
        )*/}
      </div>
    </div>
    <div id='video' className='video'>
    <a href="https://youtu.be/-NA7QJW7kXA" target="_blank" rel="noopener noreferrer" className="menu-button">
      <FaYoutube size={100} />
      <span>Assista a vídeos de como utilizar a ferramenta web da TS Tripas</span>
    </a>  
    </div>
    </>
  );
};

export default Menu;